import { ActionIcon, Badge, Image, UnstyledButton } from '@mantine/core';
import { IconTrash } from '@tabler/icons-react';
import type { AdminCaseImage } from '../api/cases';

export function ImageThumb({
  image,
  onOpen,
  onRemove,
}: {
  image: AdminCaseImage;
  onOpen: () => void;
  onRemove?: () => void;
}) {
  return (
    // Explicit width on every element in this chain keeps the thumbnail
    // flush with its SimpleGrid column even when a narrow/portrait photo
    // would otherwise render at its own intrinsic width — without this,
    // the absolutely-positioned remove button below drifts off the
    // visible image's edge. Mantine's Image already sets width:100% via
    // its own CSS class, but that's an external stylesheet rule that can
    // be starved by cascade/layout context; the `w`/style props here
    // compile to inline styles, which always win.
    <div style={{ position: 'relative', width: '100%' }}>
      <UnstyledButton
        onClick={onOpen}
        aria-label={`Open ${image.capture_type} image ${image.id}`}
        style={{ position: 'relative', display: 'block', width: '100%' }}
      >
        <Image
          src={image.presigned_url}
          alt={`${image.capture_type} image`}
          radius="sm"
          h={120}
          w="100%"
          fit="cover"
        />
        <Badge
          size="xs"
          variant="filled"
          color={image.is_primary ? 'cyan' : 'gray'}
          style={{ position: 'absolute', top: 4, left: 4 }}
        >
          {image.capture_type}
        </Badge>
      </UnstyledButton>
      {onRemove && (
        <ActionIcon
          variant="filled"
          color="red"
          size="sm"
          onClick={onRemove}
          aria-label={`Remove image ${image.id}`}
          style={{ position: 'absolute', top: 4, right: 4 }}
        >
          <IconTrash size={14} />
        </ActionIcon>
      )}
    </div>
  );
}
